<template>
  <div>
    <header id="header" class="header d-none d-md-block">
      <div class="header-wrapper header-with-border">
        <div class="container">
          <div class="row">
            <div class="col-sm-2 col-xs-2 logo-col">
              <div class="logo-wrapper">
                <a href="http://run-rus.com/">
                  <img class="logo" src="https://events.run-rus.com/Content/images/nbd/logo.png"/>
                </a>
              </div>
            </div>
            <div class="col-sm-10 col-xs-10 lk-col">
              <div class="menu-with-button">
                <div class="main-menu-button">
                  <button
                    @click="toggleMenu(false)"
                    type="button" class="navbar-toggle" data-toggle="collapse"
                    data-target="#navbar-main-menu" aria-expanded="false" aria-controls="navbar">
                    <div class="lines">
                      <span class="icon-bar"></span>
                      <span class="icon-bar"></span>
                      <span class="icon-bar"></span>
                    </div>
                    <span>Меню</span>
                  </button>
                </div>
                <nav
                  class="main-menu collapse"
                  :class="menuIsOpen ? 'in' : ''"
                >
                  <ul class="nav navbar-nav">
                    <li
                      v-for="(item, i) in nav"
                      :class="{'active': item.active}"
                      :key="i"
                    >
                      <a :href="item.link">{{ item.text }}</a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="d-md-none">
      <nav
        class="menu"
        :class="{'open': menuIsOpen}"
      >
        <div
          class="burger"
          :class="{'open': menuIsOpen}"
          @click="toggleMenu(true)"
        >
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="menu_wrap">
          <div class="wrap">
            <ul>
              <li
                v-for="(item, i) in nav"
                :class="{'active': item.active}"
                :key="i"
              >
                <a :href="item.link">{{ item.text }}</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div class="topblock">
        <div class="blockin">
          <div class="sitetitle">Клубы</div>
        </div>
      </div>
    </div>
    <div class="header-offset"></div>
  </div>
</template>

<script>
export default {
  name: 'HeaderNbd',
  data () {
    return {
      menuIsOpen: false,
      nav: [
        {
          text: 'Организаторам',
          link: 'https://run-rus.com/organizer.html'
        },
        {
          text: 'Календарь',
          link: 'https://events.run-rus.com/'
        },
        {
          text: 'Чемпионаты',
          link: 'https://champs.run-rus.com/'
        },
        {
          text: 'Клубы',
          link: 'https://clubs.run-rus.com/',
          active: true
        },
        {
          text: 'Обучение',
          link: 'https://edu.run-rus.com/'
        },
        {
          text: 'Об НБД',
          link: 'https://run-rus.com/about.html'
        }
      ]
    }
  },
  methods: {
    toggleMenu (mobile) {
      this.menuIsOpen = !this.menuIsOpen
      if (mobile) {
        document.body.style.overflowY = this.menuIsOpen ? 'hidden' : ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  // grid
  .col-sm-2, .col-sm-10 {
    float: left;
    position: relative;
    min-height: 1px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .container {
    max-width: 1200px;
    margin-right: auto;
    margin-left: auto;
    padding-left: 15px;
    padding-right: 15px;

    @media(max-width: 1076px) {
      padding: 0;
    }
  }

  .row {
    margin-left: -15px;
    margin-right: -15px;

    &::after {
      clear: both;
    }
  }

  .row, .container, .nav {

    &::before, &::after {
      content: " ";
      display: table;
    }
  }

  // mobile
  .topblock {
    background-color: $color-white;
    padding: 15px 15px;
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    right: 0;
  }

  .blockin {
    margin: 0 auto;
  }

  .sitetitle {
    line-height: 25px;
    font-size: 20px;
    overflow: hidden;
    padding-left: 50px;
  }

  .menu {
    position: fixed;
    height: 100vh;
    top: 0;
    left: 0;
    right: 100%;
    z-index: 102;
    transition: all 0.4s ease 0s;
    background-color: #fff;
    color: #333;

    &.open {
      right: 0;
    }

    .menu_wrap {
      width: 100%;
      height: 100vh;
      overflow: hidden;
      box-sizing: border-box;

      .wrap {
        overflow-x: hidden;
        overflow-y: auto;
        height: 100vh;
        min-width: 320px;
      }
    }

    ul {
      padding: 0;
      margin: 0;
      list-style: none;
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    }

    li {
      list-style: none;
    }

    a {
      display: block;
      text-decoration: none;
      font-size: 16px;
      line-height: 21px;
      padding: 15px 10px;
      color: #333;
      border-bottom: 1px solid #edf0f7;
    }
  }

  .burger {
    position: absolute;
    top: 15px;
    right: -50px;
    width: 35px;
    height: 23px;
    transform: rotate(0deg);
    transition: .5s ease-in-out;
    cursor: pointer;

    &.open {
      right: 15px;

      span {

        &:first-child, &:nth-child(4) {
          height: 0;
        }

        &:nth-child(2) {
          transform: rotate(45deg);
        }

        &:nth-child(3) {
          transform: rotate(-45deg);
        }
      }
    }

    span {
      display: block;
      position: absolute;
      height: 3px;
      width: 100%;
      opacity: 1;
      left: 0;
      transform: rotate(0deg);
      transition: .25s ease-in-out;
      background-color: #108cce;

      &:first-child {
        top: 0;
      }

      &:nth-child(2), &:nth-child(3) {
        top: 10px;
      }

      &:nth-child(4) {
        top: 20px;
      }
    }
  }

  //desktop
  #header {
    font-size: 14px;
    line-height: 1.42857;
    width: 100%;
    position: fixed;
    z-index: 9000;
    background-repeat: no-repeat;
    font-weight: 300;
    height: 73px;
    -webkit-font-smoothing: initial;
    -moz-osx-font-smoothing: initial;

    @media (max-width: 1075px) {
      height: 47px;
    }
  }

  .header-wrapper {
    height: 100%;

    &.header-with-border {
      border-bottom: 1px solid rgba(1, 91, 129, .3);
      box-shadow: 0 0 4px 0 rgba(1,91,129,.5);
      background-color: $color-white;
    }
  }

  .logo-col {
    display: table;
    table-layout: fixed;
    height: 80px;
    width: 16.66666667%;
  }

  .logo-wrapper {
    display: table-cell;
    padding: 0;
    vertical-align: top;

    a {
      text-decoration: none;
      outline: none;
    }
  }

  .logo {
    max-height: 70px;
    vertical-align: top;

    @media(max-width: 1210px) {
      display: block;
      margin-left: auto;
      margin-right: auto;
    }

    @media (max-width: 1075px) {
      width: 60.5px;
    }
  }

  .lk-col {
    padding: 0;
    width: 80%;
  }

  .main-menu {
    clear: none;
    float: left;

    @media (max-width: 1075px) {
      display: none;

      &.collapse.in {
        display: block;
      }
    }
  }

  .nav {

    @media (max-width: 1075px) {
      float: none;
      padding-top: 0!important;
      width: 150px;
    }
  }

  .navbar-nav {
    float: left;
    margin: 0;

    @media (max-width: 1075px) {
      background: $color-white;
      border-radius: 5px;
      margin: 10px 0 0 8px;
      float: left;
      border: 1px solid #027db4;
    }

    li {
      position: relative;
      display: block;
      padding: 5px 0 12px;
      margin: 10px 0 0 0;
      float: left;
    }

    li.active a {
      background-color: rgba(1, 91, 129, .157);
      color: #027db4;
    }

    a {
      outline: none;
      text-decoration: none;
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      transition: .3s;
      font-weight: 400;
      font-style: normal;
      color: #027db4;
      padding: 11px 14.75px;
      font-size: 16px;
      line-height: 20px;
      letter-spacing: unset;
      vertical-align: middle;
    }
  }

  .main-menu-button {

    @media (max-width: 1075px) {
      clear: none;
      float: none;
      margin-top: 0;
      margin-right: 15px;
      width: 100px;
    }

    div {
      display: inline-block;
      vertical-align: middle;
    }

    div + span {
      display: inline-block;
      vertical-align: middle;
      padding-left: 5px;
    }
  }

  .navbar-toggle {
    display: none;
    position: relative;
    float: right;
    padding: 9px 10px;
    border-radius: 4px;
    margin: 3px 0 0 0;
    border: 1px solid transparent;
    background: #027db4;
    color: $color-white;

    @media (max-width: 1075px) {
      display: block;
    }

    .icon-bar {
      display: block;
      width: 22px;
      height: 2px;
      border-radius: 1px;
      background: #fff;
      line-height: 1;
    }

    .icon-bar + .icon-bar {
      margin-top: 4px;
    }
  }

  .header-offset {
    flex: 0 0 auto;
    height: 55px;

    @media (min-width: breakpoint(md)) {
      height: 47px;
    }

    @media (min-width: 1076px) {
      height: 73px;
    }
  }
</style>
